import {
  Component,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { assets } from '../../../core/constants/assets.const';
import { MatSelectModule } from '@angular/material/select';
import { SearchModule } from '../search/search.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { LoginComponent } from '../../../modals/auth/login/login.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MemberStep1Component } from '../../../modals/become-member/member-step1/member-step1.component';
import { Subject, Subscription } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { User } from '../../../models/auth.model';
import { SpinnerService } from '../../../services/spinner.service';
import { CommonResponse } from '../../../models/common.model';
import { responseStatus } from '../../../core/constants/responseStatus.const';
import { environment } from '../../../../environments/environment';
import { ToasterService } from '../../../services/toaster.service';
import {
  packageCategoryTypes,
  purchaseType
} from '../../../core/constants/booking.const';
import { PackageService } from '../../../services/package.service';
import { categoryFilter, categoryResponse } from '../../../models/home.model';
import { CommonService } from '../../../services/common.service';
import { languageConversionPipe } from '../../pipes/language-pipe.pipe';
import { CurrencyService } from '../../../services/currency.service';
import { TravelService } from '../../../services/travel.service';
import { MembershipService } from '../../../services/membership.service';

@Component({
  selector: 'xplora-website-header',
  standalone: true,
  imports: [
    RouterModule,
    MatSelectModule,
    SearchModule,
    MatMenuModule,
    MatIconModule,
    MatDialogModule,
    CommonModule,
    TranslateModule,
    languageConversionPipe
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy: Subject<boolean> = new Subject<boolean>();
  private subscriptionSubject$!: Subscription;
  protected profileDetails: User | null = null;
  protected assetsConst = assets;
  isScrolled = false;
  conciergeDropdownOpen: boolean = false
  protected selectedLanguage: string | null = null;
  protected purchaseTypes = purchaseType;
  protected packageCategoryTypes = packageCategoryTypes;
  protected categoryArray: Array<categoryResponse> = [];
  protected cartCountSubscription: Subscription;
  protected totalCartCount: number | null = null;
  isTravelOpen = false;
  experiencesDropdownOpen = false;
  public countriesList: { name: string; name_ar: string }[] = [];
  travelDropdownOpen = false;
  protected guestId: string | null = null;
  protected isMember: boolean | null = null;
  hasMembership = false;
  membershipStatus: boolean = false;
   private intervalId: any;
  isLoggedIn = false
  constructor(
    public dialog: MatDialog,
    private spinnerService: SpinnerService,
    private _authService: AuthService,
    private _commonService: CommonService,
    private travelService: TravelService,
    private router: Router,
    private _toastrService: ToasterService,
    private _translateService: TranslateService,
    private _packageService: PackageService,
    public currencyService: CurrencyService,
    private membershipService: MembershipService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.getCountries()
    this.cartCountSubscription = this._authService.cartCount.subscribe(
      cartCount => {
        if (cartCount || cartCount === 0) {
          this.totalCartCount = cartCount;
        }
      }
    );
    if (isPlatformBrowser(this.platformId)) {
      this.selectedLanguage = localStorage.getItem(environment.langKey) ? localStorage.getItem(environment.langKey) : 'en';
      this.subscriptionSubject$ = this._authService.profileDetails
        .pipe(takeUntil(this.destroy))
        .subscribe({
          next: (res: User | null) => {
            this.profileDetails = res;
            // console.log('Profile Details:', this.profileDetails);
          }
        });
      this.getCategories();
    }
  }
  // ngOnInit(): void {
  //   if (isPlatformBrowser(this.platformId)) {
  //     this.isLoggedIn = !!localStorage.getItem(environment.rememberMeKey) || !!localStorage.getItem(environment.storageKey);

  //     const status = localStorage.getItem('membershipStatus');
  //     this.membershipStatus = status === 'true';

  //     // console.log('Is Logged In:', this.isLoggedIn);
  //     // console.log('Membership Status:', this.membershipStatus);
  //     this.intervalId = setInterval(() => {
  //         const status = localStorage.getItem('membershipStatus');
  //   this.membershipStatus = status === 'true';
  //   // console.log(this.membershipStatus)
  //     }, 1000);
  //   }
  // }
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isLoggedIn = !!localStorage.getItem(environment.rememberMeKey) || !!localStorage.getItem(environment.storageKey);

      // Subscribe to membership status changes
      this._authService.membershipStatus
        .pipe(takeUntil(this.destroy))
        .subscribe(status => {
          this.membershipStatus = status;
        });

      // Initialize membership status - but only if user is logged in
      if (this.isLoggedIn) {
        const initialStatus = this._authService.getMembershipStatus();
        this._authService.membershipStatus.next(initialStatus);
      } else {
        // If user is not logged in, ensure membership status is false
        this._authService.updateMembershipStatus(false);
      }
    }
  }

  @HostListener('window:scroll', [])
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onWindowScroll(): any {
    this.closeMenu()
    if (isPlatformBrowser(this.platformId)) {
      this.isScrolled = window.pageYOffset > 10;
    }
  }
  getCountries() {
    this.spinnerService.addToLoader('getcountries');

    this.travelService.getallcountries().subscribe({
      next: (resp: any) => {
        if (Array.isArray(resp?.data)) {
          this.countriesList = resp.data.map((country: any) => ({
            name: country.name,
            name_ar: country.name_ar
          }));
        }
      },
      error: () => { },
      complete: () => {
        this.spinnerService.removeFromLoader('getcountries');
      }
    });
  }

  traveldetails(title: string) {
    this.router.navigate(['/travel-details', title]);
  }

  openLoginModal(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
      panelClass: ['modal', 'auth_modal']
    });
    dialogRef.afterClosed().subscribe(() => { });
  }

  openMemberStep1Modal(): void {
    const dialogRef = this.dialog.open(MemberStep1Component, {
      panelClass: ['modal', 'auth_modal', 'setup_modal']
    });
    dialogRef.afterClosed().subscribe(() => { });
  }

  protected getCategories(): void {
    this._packageService
      .getAllCategories()
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: categoryFilter) => {
          this.categoryArray = res.categories;
        },
        error: () => { }
      });
  }

  logout(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this._authService.logoutAlert().then((res: any) => {
      if (
        Object.prototype.hasOwnProperty.call(res, 'value') &&
        res.isConfirmed === true
      ) {
        this.spinnerService.addToLoader('logout');
        this._authService
          .logout()
          .pipe(takeUntil(this.destroy))
          .subscribe({
            next: (res: CommonResponse) => {
              if (res.statusCode === responseStatus.SUCCESS) {
                if (isPlatformBrowser(this.platformId)) {
                  localStorage.removeItem(environment.storageKey);
                  localStorage.removeItem(environment.guestId);
                  this._authService.updateMembershipStatus(false);
                }
                this._toastrService.successToastr(
                  this._translateService.instant('LoggedOutSuccessfully')
                );
                this._authService.profileDetails.next(null);
                this.spinnerService.removeFromLoader('logout');
                this.router.navigate(['/']);
                if (isPlatformBrowser(this.platformId)) {
                  window.location.reload();
                }
              }
            },
            error: () => {
              this.spinnerService.removeFromLoader('logout');
            }
          });
      }
    });
  }

  onLangSelect(lang: 'en' | 'ar'): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(environment.langKey, lang);
    }
    this.selectedLanguage = lang;
    this._commonService.selectedLanguage.next(lang);
    this._translateService.setDefaultLang(lang);
  }

  ngOnDestroy(): void {
    this.destroy.complete();
    this.destroy.unsubscribe();
    if (this.cartCountSubscription) {
      this.cartCountSubscription.unsubscribe();
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  isActive: boolean = false;

  toggleClass(): any {
    this.isActive = !this.isActive;
  }

  toggleTravelDropdown() {
    this.isTravelOpen = !this.isTravelOpen;
    if (this.isTravelOpen) {
      this.experiencesDropdownOpen = false;
      this.conciergeDropdownOpen = false;
    }
  }

  toggleExperiencesDropdown() {
    this.experiencesDropdownOpen = !this.experiencesDropdownOpen;
    if (this.experiencesDropdownOpen) {
      this.isTravelOpen = false;
      this.conciergeDropdownOpen = false;
    }
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    const clickedInsideDropdown = target.closest('.dropdown_lt');
    if (!clickedInsideDropdown) {
      this.isTravelOpen = false;
      this.experiencesDropdownOpen = false;
      this.conciergeDropdownOpen=false
    }
  }
  scrollToPackages() {
    if (location.pathname === '/' || location.pathname === '/home') {
      // Already on home, scroll directly
      const element = document.getElementById('home-packages');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to home and trigger scroll after it loads
      this.router.navigate(['/']).then(() => {
        // Wait a bit to ensure DOM has rendered
        setTimeout(() => {
          const element = document.getElementById('home-packages');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 500); // Adjust delay as needed
      });
    }
  }

  setCurrency(curr: 'AED' | 'USD' | 'EUR') {
    this.currencyService.setCurrency(curr);
  }
  toggleConciergeDropdown() {
    this.conciergeDropdownOpen = !this.conciergeDropdownOpen;
    if (this.conciergeDropdownOpen) {
      this.isTravelOpen = false;
      this.experiencesDropdownOpen = false;
    }
  }
  closeMenu() {
    this.isActive = false;
    this.isTravelOpen = false;
    this.experiencesDropdownOpen = false;
    this.conciergeDropdownOpen = false;
  }
  gotobecomemember() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem(environment.storageKey)) {
        this.router.navigateByUrl('/become-member')
      } else {
        const dialogRef = this.dialog.open(LoginComponent, {
          panelClass: ['modal', 'auth_modal'],
          // data: {
          //   guestId: this.guestId
          // }
        });
        dialogRef.afterClosed().subscribe((res: number) => {
          if (res === responseStatus.SUCCESS) {
            this.router.navigateByUrl('/become-member')
            //  if (isPlatformBrowser(this.platformId)) {
            //   window.location.reload()
            // }
          }
        });
      }
      this.closeMenu()
    }
  }
  getmembership() {
    if (this.isMember === false) {
      this.router.navigateByUrl('/membership');
      this.closeMenu()
    } else if (this.isMember === true) {
      // already a member → maybe show profile or nothing
    } else {
      // not logged in
      // const dialogRef = this.dialog.open(LoginComponent, {
      //   panelClass: ['modal', 'auth_modal'],
      // });
      // dialogRef.afterClosed().subscribe((res: number) => {
      //   if (res === responseStatus.SUCCESS) {
      //     this.router.navigateByUrl('/become-member');
      //   }
      // });
      this.router.navigateByUrl('/membership');
      this.closeMenu()
    }
  }
}